import { useMemo } from 'react'

import { AuthConfig } from '@scouts/auth'
import { useFeatureFlagEnabled } from '@taxfix/scouts-helpers'

import { authConfig } from '../auth-config'

export const useAuthConfig = (): AuthConfig => {
    const isMfaSmsEnrollmentEnabled = !!useFeatureFlagEnabled('feat-mfa-sms-enrollment')
    return useMemo(
        () => ({
            ...authConfig,
            isMfaSmsEnrollmentEnabled,
        }),
        [isMfaSmsEnrollmentEnabled]
    )
}
